module.exports = __webpack_public_path__ + "img/9788975270017.2f03dc6b.jpg";